// extracted by mini-css-extract-plugin
export default {"weatherCard":"WeatherSourceCard_weatherCard__a9pDS"};